import { useCallback } from 'react';

import { ILazyDropdownOption, LazyDropdown } from 'components/lazyDropdown/LazyDropdown';
import { useSearchSrid } from '../api/useSridController';

interface ISridDropdownProps {
    value: ILazyDropdownOption<number> | null;
    onChange: (option: ILazyDropdownOption<number> | null) => void;
    label?: string;
    disabled?: boolean;
}

export function SridDropdown({ value, onChange, label = 'SRID', disabled }: ISridDropdownProps) {
    const { mutateAsync: searchSrid } = useSearchSrid();

    const fetchOptions = useCallback(async (term: string): Promise<ILazyDropdownOption<number>[]> => {
        const result = await searchSrid({ term });
        return result.map((item) => ({
            value: item.Srid,
            label: item.Title,
        }));
    }, [searchSrid]);

    return (
        <LazyDropdown<number>
            value={value}
            onChange={onChange}
            fetchOptions={fetchOptions}
            label={label}
            disabled={disabled}
        />
    );
}
